import { TextField } from '@mui/material';
import type { FieldRendererProps } from '../types';

/**
 * ISO-date (YYYY-MM-DD) field using the native date picker. Mobile keyboards
 * surface a date wheel automatically. For richer date+time UIs, swap in
 * @mui/x-date-pickers — out of scope for this scaffold.
 */
export function DateInput({ name, label, required, value, error, onChange }: FieldRendererProps) {
  return (
    <TextField
      name={name}
      label={label}
      required={required}
      type="date"
      InputLabelProps={{ shrink: true }}
      value={(value as string | null) ?? ''}
      onChange={(e) => onChange(e.target.value || null)}
      error={!!error}
      helperText={error ?? undefined}
    />
  );
}
